import { createDialogOptionEventListener } from '../../Inamove/Components/Dialog/DialogOption'
import { createInteractableObjectListener } from '../../Inamove/Components/InteractableObject'
import { LevelActionsAction } from '../../Inamove/Components/Level'
import Video from '../../Inamove/Components/Video/Video'
import { waypointOpenActionCreator } from '../../Inamove/Components/Waypoint'
import CinematicContainer from '../../Inamove/Containers/CinematicContainer/CinematicContainer'
import Config from '../../Inamove/Containers/Config'
import GameSceneContainer from '../../Inamove/Containers/GameSceneContainer/GameSceneContainer'
import InventoryContainer from '../../Inamove/Containers/InventoryContainer/InventoryContainer'
import LoadingContainer from '../../Inamove/Containers/LoadingContainer/LoadingContainer'
import AudioController from '../../Inamove/Controllers/AudioController'
import LevelController from '../../Inamove/Controllers/LevelController'
import LoadingController from '../../Inamove/Controllers/LoadingController'
import dispatch from '../../Inamove/Utility/dispatchAction'
import { playVideo } from '../../KUtil/help'

const levelId = 'level9'

export default async function () {
    InventoryContainer.clean()
    CinematicContainer.hide()
    GameSceneContainer.hide()
    InventoryContainer.hide()
    LoadingController.reset()
    LoadingContainer.show()

    const level = await LevelController.loadLevel(levelId)

    const IntroCinematic = new Video(Config.CINEMATIC_PATH + 'V20-anfang-tierpark' + Config.VIDEO_FILE_EXT)
    const OutroCinematic = new Video(Config.CINEMATIC_PATH + 'V21-ende-tierpark' + Config.VIDEO_FILE_EXT)
    ;[IntroCinematic, OutroCinematic].forEach(LoadingController.addToQueue)
    CinematicContainer.setVideo(IntroCinematic)

    const abZuHomerAudio = AudioController.add(
        Config.GAME_SCENE_PATH + 'K127/audio/ab-zu-homer' + Config.AUDIO_FILE_EXT
    )
    let quizDone = false

    createInteractableObjectListener('mitarbeiterin', async () => {
        level.stopGame(true)
        await level.startDialog('D5')
        level.startGame()

        if (quizDone) {
            AudioController.play(abZuHomerAudio)
        }
    })

    createDialogOptionEventListener('next-level-unlocked', () => {
        quizDone = true
        // remove waypoint to left way
        level.gameScenes.K125.waypoints.K122.hide()
        dispatch(waypointOpenActionCreator('level10'))
    })

    await AudioController.addAllToLoadingQueue()
    await LoadingController.processQueue()
    await LoadingContainer.clickStart()

    LoadingContainer.hide()
    CinematicContainer.show()
    await CinematicContainer.play()
    CinematicContainer.hide()
    GameSceneContainer.show()
    InventoryContainer.show()

    LevelController.startLevel(levelId)

    return new Promise<void>((resolve) => {
        addEventListener('Level', async (event) => {
            // @ts-ignore
            const action: LevelActionsAction = event.detail.action
            // @ts-ignore
            const level: Level = event.detail.level

            if (action === LevelActionsAction.stop && level.id === levelId) {
                await playVideo(OutroCinematic)
                resolve()
            }
        })
    })
}
